import store from '../store/index'
//-----------------------
// get toggle extra cols
//-----------------------
export default function getToggleExtraCols(headings) {
  // console.log("-----------------------");
  // console.log("IN getToggleExtraCols");
  let colNumbers = []
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat
  let maxCR = this_store.config.max_cr
  let ca_extra = this_store.config.max_ca + 1
  //------------------------
  // set field cols to show
  //------------------------
  let ca_extra_field = 'ca' + ca_extra
  //--------------------------
  // set field cols to toggle
  //--------------------------
  let fields = [
    'image',
    'seq',
    'name',
    'player_name',
    'sub_status_image',
    'fatigue_image',
    'category',
    'bleeding_image',
    'fill1',
    'extra_attack_options',
    'last_action_image',
    'next_action_image',
    'no_attack_reason',
    'fill_extra_before',
    ca_extra_field,
    'fill2',
  ]
  //--------------------
  // load cr cols names
  //--------------------
  for (let j = 1; j <= maxCR; j++) {
    let cr = 'cr' + j
    fields.push(cr)
  }
  //--------------------------------
  // get headings idx for col names
  //--------------------------------
  for (let k = 0; k < fields.length; k++) {
    let idx = headings.findIndex((a) => a.field == fields[k])
    colNumbers.push(idx)
  }
  return colNumbers
}
